export class Status {
    available: boolean;
    next_maintenance: Date;
    next_maintenance_message: string;
    next_maintenance_downtime_hours: number;
    show_maintenance_lead_days: number;
}
